var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":12}},[_c('gmap-marker',{attrs:{"position":_vm.markers},on:{"click":function($event){_vm.center=_vm.markers}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }